<template>
    <v-app id="element-to-pdf" class="portrait">
        <v-overlay :value="dLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular> Espere un momento por favor.
        </v-overlay>
        <v-row justify="center">
            <v-col cols="12" sm="3" md="3" lg="3" style="background-color:#1271A6" class="pr-0 pt-0 pl-2" justify="center">
                <v-row justify="center">
                    <v-hover v-slot="{ hover }">
                        <v-card class="mx-auto" color="grey lighten-4">
                            <v-img v-if="dPriAlumno.docs==''" src="@/assets/images/user1.jpg" max-height="200" max-width="170">
                                <v-expand-transition>
                                    <v-card-text @click="dModalDocs.dialog=true" v-if="hover" class="transition-fast-in-fast-out blue text-center title white--text" style="height: 100%;">
                                        <div><v-icon dark>edit</v-icon></div>
                                        Clic Cambiar Foto
                                    </v-card-text>
                                </v-expand-transition>
                            </v-img>
                            <v-img v-else :src="dFoto" max-height="200" max-width="170">
                                <v-expand-transition>
                                    <v-card-text @click="dModalDocs.dialog=true" v-if="hover" class="transition-fast-in-fast-out blue text-center title white--text" style="height: 100%;">
                                        <div><v-icon dark>edit</v-icon></div>
                                        Clic Cambiar Foto
                                    </v-card-text>
                                </v-expand-transition>
                            </v-img>
                        </v-card>
                    </v-hover>
                </v-row>
                <v-card class="mt-0" style="background-color:#1271A6">
                    <v-card-text class="pb-0 pr-1 pl-0 pt-0">
                        <v-list two-line color="#1271A6" dark>
                            <v-list-item class="px-0" style="height:10px">
                                <v-list-item-icon  class='mr-1'><v-icon>person</v-icon></v-list-item-icon>
                                <v-list-item-content><h3>{{dPriAlumno.Alumno}}</h3><v-list-item-subtitle>Apellidos y Nombres</v-list-item-subtitle></v-list-item-content>
                            </v-list-item>
                            <v-list-item class="px-0" style="height:10px">
                                <v-list-item-icon  class='mr-1'><v-icon>credit_card</v-icon></v-list-item-icon>
                                <v-list-item-content><v-list-item-title>{{dPriAlumno.DNI}}</v-list-item-title><v-list-item-subtitle>DNI</v-list-item-subtitle></v-list-item-content>
                            </v-list-item>
                            <v-list-item class="px-0" style="height:10px">
                                <v-list-item-icon  class='mr-1'><v-icon>qr_code_2</v-icon></v-list-item-icon>
                                <v-list-item-content><v-list-item-title>{{dPriAlumno.Codigo}}</v-list-item-title><v-list-item-subtitle>Codigo</v-list-item-subtitle></v-list-item-content>
                            </v-list-item>
                            <v-list-item class="px-0" style="height:10px">
                                <v-list-item-icon  class='mr-1'><v-icon>bookmark</v-icon></v-list-item-icon>
                                <v-list-item-content><span>{{dPriAlumno.priservicio.Descripcion}}</span><v-list-item-subtitle>Carrera</v-list-item-subtitle></v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                </v-card>
                <v-card class="mt-2" style="background-color:#1271A6">
                    <v-card-title class=" py-0" style="border-bottom:2pt solid white">
                        <span class="title mb-1" style="color:white">CONTACTO</span>
                        <v-spacer></v-spacer>
                        <v-menu bottom right>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on" dark><v-icon>more_vert</v-icon></v-btn>
                            </template>
                            <v-list>
                                <v-list-item>
                                    <v-list-item-title><v-btn @click="fuPriAlumnoModalOpen()" color="warning" block><v-icon>edit</v-icon> Editar</v-btn></v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-card-title>
                    <v-card-text class="pb-0 pr-1 pl-0">
                        <v-list two-line color="#1271A6" dark>
                            <v-list-item class="px-0" style="height:10px">
                                <v-list-item-icon  class='mr-1'><v-icon>smartphone</v-icon></v-list-item-icon>
                                <v-list-item-content><span>{{dPriAlumno.Celular}}</span><v-list-item-subtitle>Celular</v-list-item-subtitle></v-list-item-content>
                            </v-list-item>
                            <v-list-item class="px-0" style="height:10px">
                                <v-list-item-icon  class='mr-1'><v-icon>email</v-icon></v-list-item-icon>
                                <v-list-item-content><span>{{dPriAlumno.Email}}</span><v-list-item-subtitle>Correo Personal</v-list-item-subtitle></v-list-item-content>
                            </v-list-item>
                            <v-list-item class="px-0" style="height:10px">
                                <v-list-item-icon  class='mr-1'><v-icon>place</v-icon></v-list-item-icon>
                                <v-list-item-content><span>{{dPriAlumno.Direccion}}</span><v-list-item-subtitle>Dirección</v-list-item-subtitle></v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                </v-card>
                <v-card class="mt-2" style="background-color:#1271A6">
                    <v-card-title class=" py-0" style="border-bottom:2pt solid white">
                        <span class="title mb-1" style="color:white">PERFIL</span>
                        <v-spacer></v-spacer>
                        <v-menu bottom right>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on" dark><v-icon>more_vert</v-icon></v-btn>
                            </template>
                            <v-list>
                                <v-list-item>
                                    <v-list-item-title><v-btn @click="fuPerfilModalOpen()" color="warning" block><v-icon>edit</v-icon> Editar</v-btn></v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-card-title>
                    <v-card-text class="pb-0 pr-1 pl-0">
                        <p v-if="dPriPersonaMetaValuesPerfil.length>0" class="pa-1 white--text">{{fuJson(dPriPersonaMetaValuesPerfil[0].value, 0)}}</p>
                    </v-card-text>
                </v-card>
                <v-card class="mt-2" style="background-color:#1271A6">
                    <v-btn @click="fuPdf()" small text dark block><v-icon>file_download</v-icon> Descargar</v-btn>
                </v-card>
            </v-col>
            <v-col cols="12" sm="9" md="9" lg="9" style="background-color:#f5f5f5" class="pa-1">
                <v-card style="background-color:#f5f5f5">
                    <v-card-title class=" py-0" style="border-bottom:4pt solid #1271A6;">
                        <span class="title mb-1" style="color:#1271A6">IDIOMA</span>
                        <v-spacer></v-spacer>
                        <v-btn @click="fuPriPersonaMetaValueModalOpen('Idioma')" color="#1271A6" x-large icon><v-icon>add</v-icon></v-btn>
                    </v-card-title>
                    <v-card-text class="pa-0">
                        <v-timeline dense>
                            <v-timeline-item v-for="(item, i) in dPriPersonaMetaValuesIdioma" :key="i" color="#1271A6" small class="pa-0">
                                <v-row>
                                    <v-col cols="2" class="pa-0">
                                        <strong>{{fuJson(item.value, 0)}} - {{fuJson(item.value, 1)}}</strong>
                                    </v-col>
                                    <v-col cols="9" class="pa-0">
                                        <h4 :class="`font-weight`" style="color:#1271A6">{{fuJson(item.value, 2).toUpperCase()}}</h4>
                                        <div class="body-2">{{fuJson(item.value, 3)}}</div>
                                        <div class="caption">{{fuJson(item.value, 4)}}</div>
                                    </v-col>
                                    <v-col cols="1" class="pa-0">
                                        <v-menu bottom left>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-bind="attrs" v-on="on"><v-icon>more_vert</v-icon></v-btn>
                                            </template>
                                            <v-list>
                                                <v-list-item>
                                                    <v-list-item-title><v-btn @click="fuPriPersonaMetaValueEdit(item)" color="warning" block><v-icon>edit</v-icon> Editar</v-btn></v-list-item-title>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-title><v-btn @click="fuPriPersonaMetaValueEliminar(item)" color="error" block dark><v-icon>delete</v-icon> Eliminar</v-btn></v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </v-col>
                                </v-row>
                            </v-timeline-item>
                        </v-timeline>
                    </v-card-text>
                </v-card>
                <v-card style="background-color:#f5f5f5">
                    <v-card-title class=" py-0" style="border-bottom:4pt solid #1271A6;">
                        <span class="title mb-1" style="color:#1271A6">FORMACIÓN ACADÉMICA</span>
                        <v-spacer></v-spacer>
                        <v-btn @click="fuPriPersonaMetaValueModalOpen('Formacion')" color="#1271A6" x-large icon><v-icon>add</v-icon></v-btn>
                    </v-card-title>
                    <v-card-text class="pa-0">
                        <v-timeline dense>
                            <v-timeline-item v-for="(item, i) in dPriPersonaMetaValuesFormacion" :key="i" color="#1271A6" small class="pa-0">
                                <v-row>
                                    <v-col cols="2" class="pa-1">
                                        <strong>{{fuJson(item.value, 0)}} - {{fuJson(item.value, 1)}}</strong>
                                    </v-col>
                                    <v-col cols="9" class="pa-1">
                                        <h4 :class="`font-weight`" style="color:#1271A6">{{fuJson(item.value, 2).toUpperCase()}}</h4>
                                        <div class="body-2">{{fuJson(item.value, 3)}}</div>
                                        <div class="caption">{{fuJson(item.value, 4)}}</div>
                                    </v-col>
                                    <v-col cols="1" class="pa-0">
                                        <v-menu bottom left>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-bind="attrs" v-on="on"><v-icon>more_vert</v-icon></v-btn>
                                            </template>
                                            <v-list>
                                                <v-list-item>
                                                    <v-list-item-title><v-btn @click="fuPriPersonaMetaValueEdit(item)" color="warning" block><v-icon>edit</v-icon> Editar</v-btn></v-list-item-title>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-title><v-btn @click="fuPriPersonaMetaValueEliminar(item)" color="error" block dark><v-icon>delete</v-icon> Eliminar</v-btn></v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </v-col>
                                </v-row>
                            </v-timeline-item>
                        </v-timeline>
                    </v-card-text>
                </v-card>
                <v-card style="background-color:#f5f5f5">
                    <v-card-title class=" py-0" style="border-bottom:4pt solid #1271A6;">
                        <span class="title mb-1" style="color:#1271A6">ESPECIALIZACIÓN</span>
                        <v-spacer></v-spacer>
                        <v-btn @click="fuPriPersonaMetaValueModalOpen('Especializacion')" color="#1271A6" x-large icon><v-icon>add</v-icon></v-btn>
                    </v-card-title>
                    <v-card-text class="pa-0">
                        <v-timeline dense>
                            <v-timeline-item v-for="(item, i) in dPriPersonaMetaValuesEspecializacion" :key="i" color="#1271A6" small class="pa-0">
                                <v-row>
                                    <v-col cols="2" class="pa-1">
                                        <strong>{{fuJson(item.value, 0)}} - {{fuJson(item.value, 1)}}</strong>
                                    </v-col>
                                    <v-col cols="9" class="pa-1">
                                        <h4 :class="`font-weight`" style="color:#1271A6">{{fuJson(item.value, 2).toUpperCase()}}</h4>
                                        <div class="body-2">{{fuJson(item.value, 3)}}</div>
                                        <div class="caption">{{fuJson(item.value, 4)}}</div>
                                    </v-col>
                                    <v-col cols="1" class="pa-0">
                                        <v-menu bottom left>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-bind="attrs" v-on="on"><v-icon>more_vert</v-icon></v-btn>
                                            </template>
                                            <v-list>
                                                <v-list-item>
                                                    <v-list-item-title><v-btn @click="fuPriPersonaMetaValueEdit(item)" color="warning" block><v-icon>edit</v-icon> Editar</v-btn></v-list-item-title>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-title><v-btn @click="fuPriPersonaMetaValueEliminar(item)" color="error" block dark><v-icon>delete</v-icon> Eliminar</v-btn></v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </v-col>
                                </v-row>
                            </v-timeline-item>
                        </v-timeline>
                    </v-card-text>
                </v-card>
                <v-card style="background-color:#f5f5f5">
                    <v-card-title class=" py-0" style="border-bottom:4pt solid #1271A6;">
                        <span class="title mb-1" style="color:#1271A6">EXPERIENCIA LABORAL</span>
                        <v-spacer></v-spacer>
                        <v-btn @click="fuPriPersonaMetaValueModalOpen('Laboral')" color="#1271A6" x-large icon><v-icon>add</v-icon></v-btn>
                    </v-card-title>
                    <v-card-text class="pa-0">
                        <v-timeline dense>
                            <v-timeline-item v-for="(item, i) in dPriPersonaMetaValuesLaboral" :key="i" color="#1271A6" small class="pa-0">
                                <v-row>
                                    <v-col cols="2" class="pa-1">
                                        <strong>{{fuJson(item.value, 0)}} - {{fuJson(item.value, 1)}}</strong>
                                    </v-col>
                                    <v-col cols="9" class="pa-1">
                                        <h4 :class="`font-weight`" style="color:#1271A6">{{fuJson(item.value, 2).toUpperCase()}}</h4>
                                        <div class="body-2">{{fuJson(item.value, 3)}}</div>
                                        <div v-if="fuJson(item.value, 4) !=''" class="caption">{{fuJson(item.value, 4)}}</div>
                                    </v-col>
                                    <v-col cols="1" class="pa-0">
                                        <v-menu bottom left>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-bind="attrs" v-on="on"><v-icon>more_vert</v-icon></v-btn>
                                            </template>
                                            <v-list>
                                                <v-list-item>
                                                    <v-list-item-title><v-btn @click="fuPriPersonaMetaValueEdit(item)" color="warning" block><v-icon>edit</v-icon> Editar</v-btn></v-list-item-title>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-title><v-btn @click="fuPriPersonaMetaValueEliminar(item)" color="error" block dark><v-icon>delete</v-icon> Eliminar</v-btn></v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </v-col>
                                </v-row>
                            </v-timeline-item>
                        </v-timeline>
                    </v-card-text>
                    <!-- <v-card-text style="height: 50px; position: relative">
                        <v-fab-transition>
                            <v-btn @click="fuPdf()" color="#1271A6" dark absolute bottom right fab><v-icon>download</v-icon></v-btn>
                        </v-fab-transition>
                    </v-card-text> -->
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="dModalDocs.dialog" max-width="500">
            <template>
                <v-form ref="refModalDocs">
                    <v-card :loading="dModalDocs.IsUpdating">
                        <v-toolbar class="justify-end" color="#1271A6">
                            <span class="headline" style="color:white">CAMBIAR FOTO</span>
                            <v-spacer></v-spacer>
                            <v-btn @click="fuModalDocsSave()" style="color:#1271A6" :loading="dModalDocs.IsUpdating"><v-icon>save</v-icon> Guardar</v-btn>
                            <v-btn @click="dModalDocs.dialog=false" icon dark class="ml-5" title="Cerrar"><v-icon>close</v-icon></v-btn>
                        </v-toolbar>
                        <v-card-text fluid>
                            <v-file-input v-model="dSelectedFile" label="Seleccionar Foto" filled :rules="[v => !!v || 'El campo es requerido']"></v-file-input>
                        </v-card-text>
                    </v-card>
                </v-form>
            </template>
        </v-dialog>
        <v-dialog v-model="dPerfilModal.dialog" max-width="1000">
            <template>
                <v-form ref="refPerfilModal">
                    <v-card :loading="dPerfilModal.IsUpdating">
                        <v-toolbar class="justify-end" color="#1271A6">
                            <span class="headline" style="color:white">PERFIL</span>
                            <v-spacer></v-spacer>
                            <v-btn @click="fuPerfilSave()" style="color:#1271A6" :loading="dPerfilModal.IsUpdating"><v-icon>save</v-icon> Guardar</v-btn>
                            <v-btn @click="dPerfilModal.dialog=false" icon dark class="ml-5" title="Cerrar"><v-icon>close</v-icon></v-btn>
                        </v-toolbar>
                        <v-card-text fluid>
                            <v-textarea solo name="Perfil" v-model="dPerfil"></v-textarea>
                        </v-card-text>
                    </v-card>
                </v-form>
            </template>
        </v-dialog>
        <v-dialog v-model="dPriAlumnoModal.dialog" max-width="500">
            <template>
                <v-form ref="refPriAlumnoModal">
                    <v-card :loading="dPriAlumnoModal.IsUpdating">
                        <v-toolbar class="justify-end" color="#1271A6">
                            <span class="headline" style="color:white">CONTACTO</span>
                            <v-spacer></v-spacer>
                            <v-btn @click="fuPriAlumnoSave()" style="color:#1271A6" :loading="dPriAlumnoModal.IsUpdating"><v-icon>save</v-icon> Guardar</v-btn>
                            <v-btn @click="dPriAlumnoModal.dialog=false" icon dark class="ml-5" title="Cerrar"><v-icon>close</v-icon></v-btn>
                        </v-toolbar>
                        <v-card-text fluid>
                            <v-text-field v-model="dPriAlumnoUpdate.Celular" label="* Celular" :disabled="dPriAlumnoModal.IsUpdating" filled prepend-inner-icon="smartphone" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length <= 9) || 'El campo debe ser menor de 9 caracteres.']" :maxlength="9" autocomplete="off"></v-text-field>
                            <v-text-field v-model="dPriAlumnoUpdate.Email" label="Correo Electrónico" :disabled="dPriAlumnoModal.IsUpdating" filled prepend-inner-icon="email" :maxlength="100" autocomplete="off"></v-text-field>
                            <v-text-field v-model="dPriAlumnoUpdate.Direccion" label="Dirección - Referencia" :disabled="dPriAlumnoModal.IsUpdating" filled prepend-inner-icon="location_on" :maxlength="80" autocomplete="off"></v-text-field>
                        </v-card-text>
                    </v-card>
                </v-form>
            </template>
        </v-dialog>
        <v-dialog v-model="dPriPersonaMetaValueModal.dialog" max-width="1000">
            <template>
                <v-form ref="refPriPersonaMetaValueModal">
                    <v-card :loading="dPriPersonaMetaValueModal.IsUpdating">
                        <v-toolbar class="justify-end" color="#1271A6">
                            <span class="headline" style="color:white">{{ dPriPersonaMetaValueModal.title }}</span>
                            <v-spacer></v-spacer>
                            <v-btn @click="fuPriPersonaMetaValueSave()" style="color:#1271A6" :loading="dPriPersonaMetaValueModal.IsUpdating"><v-icon>save</v-icon> Guardar</v-btn>
                            <v-btn @click="dPriPersonaMetaValueModal.dialog = false" icon dark class="ml-5" title="Cerrar"><v-icon>close</v-icon></v-btn>
                        </v-toolbar>
                        <v-card-text fluid>
                            <v-row dense>
                                <v-col cols="12" xm="6" sm="6">
                                    <v-autocomplete v-model="dPriPersonaMetaValue.inicio_at" label="* Año Inicio" :items="dYears" filled prepend-inner-icon="event_note" :rules="[v => !!v || 'El campo es requerido']"></v-autocomplete>
                                </v-col>
                                <v-col cols="12" xm="6" sm="6">
                                    <v-autocomplete v-model="dPriPersonaMetaValue.end_at" label="Año Fin" :items="dYears" filled prepend-inner-icon="event_note"></v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" xm="12" sm="12">
                                    <v-text-field v-model="dPriPersonaMetaValue.instituto" :label=cLabel3 prepend-inner-icon="account_balance" outlined dense :rules="[v => !!v || 'El campo es requerido']" :maxlength="100" autocomplete="off"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" xm="12" sm="12">
                                    <v-text-field v-model="dPriPersonaMetaValue.carrera" :label=cLabel4 prepend-inner-icon="bookmark" outlined dense :rules="[v => !!v || 'El campo es requerido']" :maxlength="100" autocomplete="off"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" xm="12" sm="12">
                                    <v-textarea v-model="dPriPersonaMetaValue.detalle" label="Detalle" outlined name="Detalle" rows="3"></v-textarea>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-form>
            </template>
        </v-dialog>
    </v-app>
</template>
<script>
import html2pdf from 'html2pdf.js';
import gql from 'graphql-tag';
import 'sweetalert2/src/sweetalert2.scss';
import Swal from 'sweetalert2/dist/sweetalert2.js';

export default {
    name: 'AlumnoCVByAlumno',
    mounted(){
        if (this.$route.params.pIdAlumno){
            this.fuLoad(parseInt(this.$route.params.pIdAlumno));
            this.dPriAlumno.IdAlumno = this.$route.params.pIdAlumno;
        }
        let today = new Date();        
        for (var i = today.getFullYear(); i >= today.getFullYear()-80; i--) {
            this.dYears.push(i);
        }
    },
    data: () => ({
        dFoto: '',
        dLoading: false,
        dPerfil: '',
        dModalDocs: {
            dialog: false,
            IsUpdating: false,
        },
        dSelectedFile: null,
        dPerfilModal: {
            dialog: false,
            IsUpdating: false,
        },
        dPriAlumnoModal: {
            dialog: false,
            IsUpdating: false,
        },
        dPriAlumno: {
            IdAlumno: '',
            Alumno: '',
            DNI: '',
            Codigo: '',
            Celular: '',
            Direccion: '',
            Email: '',
            docs: '',
            priservicio: {
                Iniciales: '',
                Descripcion: '',
            }
        },
        dPriAlumnoUpdate: {
            Celular: '',
            Direccion: '',
            Email: '',
        },
        dPriPersonaMetaValue: {
            id: null,
            inicio_at: '',
            end_at: '',
            instituto: '',
            carrera: '',
            detalle: '',
        },
        dPriPersonaMetaValueDefault: {
            inicio_at: '',
            end_at: '',
            instituto: '',
            carrera: '',
            detalle: '',
        },
        dPriPersonaMetaValuesPerfil: [],
        dPriPersonaMetaValuesIdioma: [],
        dPriPersonaMetaValuesFormacion: [],
        dPriPersonaMetaValuesEspecializacion: [],
        dPriPersonaMetaValuesLaboral: [],
        dPriPersonaMetaValueModal: {
            title: '',
            dialog: false,
            IsUpdating: false,
        },
        dYears: [],
    }),
    computed: {
        cRuta() {
            return this.$route.params.pIdAlumno
        },
        cLabel3(){
            switch(this.dPriPersonaMetaValueModal.title){
                case "Formacion":
                case "Especializacion":
                case "Idioma":
                    return 'Institución / Universidad';
                    break;
                default: // case "Laboral":
                    return 'Empresa';
            }
        },
        cLabel4(){
            switch(this.dPriPersonaMetaValueModal.title){
                case "Formacion":
                    return 'Carrera';
                    break;
                case "Especializacion":
                    return 'Especialidad';
                    break;
                case "Idioma":
                    return 'Idioma / Nivel';
                    break;
                case "Laboral":
                    return 'Cargo';
                    break;
            }
        },
        cName3(){
            if(this.dPriPersonaMetaValueModal.title=='Formacion' || this.dPriPersonaMetaValueModal.title=='Especializacion')
                return 'instituto'
            return 'empresa'
        },
        cName4(){
            if(this.dPriPersonaMetaValueModal.title=='Formacion')
                return 'carrera'
            if(this.dPriPersonaMetaValueModal.title=='especializacion')
                return 'Especialidad'
            return 'cargo'
        },
    },
    methods: {
        fuJson(vItem, vPosition) {
            let pItem = JSON.parse(vItem);
            if (pItem.length>=vPosition+1) {
                return pItem[vPosition].value;
            } else {
                return '';
            }
        },
        async fuLoad(pIdAlumno) {
            this.dLoading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query matriculaPrev($IdAlumno: ID!){
                            prialumno(IdAlumno: $IdAlumno){
                                Alumno
                                DNI
                                Codigo
                                Celular                                
                                Direccion
                                Email
                                docs
                                priservicio{
                                    Iniciales
                                    Descripcion
                                }
                            }
                        }
                    `,fetchPolicy: 'no-cache',
                    variables: {
                        IdAlumno: pIdAlumno
                    }
                })                
                this.dPriAlumno.Alumno = response.data.prialumno.Alumno;
                this.dPriAlumno.Codigo = response.data.prialumno.Codigo;
                this.dPriAlumno.DNI = response.data.prialumno.DNI;
                this.dPriAlumno.Celular = response.data.prialumno.Celular;
                this.dPriAlumno.Direccion = response.data.prialumno.Direccion;
                this.dPriAlumno.Email = response.data.prialumno.Email;
                this.dPriAlumno.priservicio.Descripcion = response.data.prialumno.priservicio.Descripcion;

                if(response.data.prialumno.docs)
                    if(JSON.parse(response.data.prialumno.docs).FOTO){
                        this.dPriAlumno.docs = JSON.parse(response.data.prialumno.docs).FOTO
                        this.fImage(this.dPriAlumno.docs);
                    }else
                        this.dPriAlumno.docs = '';
                else
                    this.dPriAlumno.docs = '';

                this.fuPrialumnoPriPersonaMetaValue(pIdAlumno);
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
            } finally {
                this.dLoading = false;
            }
        },
        async fuPriAlumnoSave() {
            if(this.$refs.refPriAlumnoModal.validate()){
                this.fuPriAlumnoUpdate();
            }
        },
        async fuPriAlumnoUpdate () {
            try {
                this.dPriAlumnoModal.IsUpdating = true;

                const data = {
                    Celular: this.dPriAlumnoUpdate.Celular,
                    Direccion: this.dPriAlumnoUpdate.Direccion,
                    Email: this.dPriAlumnoUpdate.Email,
                }

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation prialumnoUpdate($IdAlumno: ID!, $input: prialumnoUpdateInput!){
                        prialumnoUpdate(IdAlumno: $IdAlumno, input: $input){
                            Celular
                            Direccion
                            Email
                        }
                    }`,
                    variables: {
                        IdAlumno: this.dPriAlumno.IdAlumno,
                        input: data
                    }
                });
                if(response.data){
                    Swal.fire({icon: 'success', title: 'Correcto', html: 'Se modificó correctamente.<br>'});
                    this.dPriAlumno.Celular =this.dPriAlumnoUpdate.Celular;
                    this.dPriAlumno.Direccion =this.dPriAlumnoUpdate.Direccion;
                    this.dPriAlumno.Email =this.dPriAlumnoUpdate.Email;
                    this.dPriAlumnoModal.dialog = false;
                } else {
                    Swal.fire({icon: 'error', title: '¡ ERROR !', html: 'No se guardó.<br>' + 'Intente de nuevo o comuníquese con el AREA DE TI.'})
                }
            } catch (error) {
                console.log(error);
                Swal.fire({icon: 'error',title: '¡ ERROR !',html: 'No se guardó.<br>' + 'Intente de nuevo o comuníquese con el AREA DE TI.'})
            } finally {
                this.dPriAlumnoModal.IsUpdating = false;
            }
        },
        async fuPrialumnoPriPersonaMetaValue(pIdAlumno) {
            this.dPriPersonaMetaValuesFormacion = [];
            this.dPriPersonaMetaValuesEspecializacion = [];
            this.dPriPersonaMetaValuesLaboral = [];
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumno($IdAlumno: ID!){
                        prialumno(IdAlumno: $IdAlumno){
                            pripersonametavalues{
                                id
                                nombre
                                value
                            }
                        }
                    }`,fetchPolicy: 'no-cache',
                    variables: {
                        IdAlumno: pIdAlumno
                    }
                });
                this.dPriPersonaMetaValuesPerfil = response.data.prialumno.pripersonametavalues.filter((item) => item.nombre=='Perfil');
                this.dPriPersonaMetaValuesIdioma = response.data.prialumno.pripersonametavalues.filter((item) => item.nombre=='Idioma');
                this.dPriPersonaMetaValuesFormacion = response.data.prialumno.pripersonametavalues.filter((item) => item.nombre=='Formacion');
                this.dPriPersonaMetaValuesEspecializacion = response.data.prialumno.pripersonametavalues.filter((item) => item.nombre=='Especializacion');
                this.dPriPersonaMetaValuesLaboral = response.data.prialumno.pripersonametavalues.filter((item) => item.nombre=='Laboral');
            } catch (error) {
                console.log(error);
            } finally {
            }
        },
        fuPriAlumnoModalOpen(){
            this.dPriAlumnoModal.dialog = true;
            this.dPriAlumnoUpdate = {
                Celular: this.dPriAlumno.Celular,
                Direccion: this.dPriAlumno.Direccion,
                Email: this.dPriAlumno.Email,
            }
        },
        fuPerfilModalOpen(){
            this.dPerfil = '';
            this.dPriPersonaMetaValue.id = null;
            this.dPriPersonaMetaValueModal.title='Perfil'
            this.dPerfilModal.dialog = true;
            if(this.dPriPersonaMetaValuesPerfil.length>0){
                this.dPerfil = this.fuJson(this.dPriPersonaMetaValuesPerfil[0].value, 0);
                this.dPriPersonaMetaValue.id = this.dPriPersonaMetaValuesPerfil[0].id;
            }
        },
        fuPriPersonaMetaValueModalOpen(vTitle){
            this.dPriPersonaMetaValue = Object.assign({}, this.dPriPersonaMetaValueDefault);
            this.dPriPersonaMetaValueModal.title=vTitle
            this.dPriPersonaMetaValueModal.dialog = true;
            this.dPriPersonaMetaValue.id = null;
        },
        fuPriPersonaMetaValueSave(){
            if(this.$refs.refPriPersonaMetaValueModal.validate()){
                let vValue = [
                    {type: 'year', name: 'inicio_at', label: 'Año de Inicio', value: this.dPriPersonaMetaValue.inicio_at, class: 'col-span-2'},
                    {type: 'year', name: 'end_at', label: 'Año de Termino', value: this.dPriPersonaMetaValue.end_at, class: 'col-span-2'},
                    {type: 'text', name: this.cName3, label: this.cLabel3, value: this.dPriPersonaMetaValue.instituto, class: 'col-span-8'},
                    {type: 'text', name: this.cName4, label: this.cLabel4, value: this.dPriPersonaMetaValue.carrera, class: 'col-span-10'},
                    {type: 'text', name: 'detalle', label: 'Detalle', value: this.dPriPersonaMetaValue.detalle, class: 'col-span-10'},
                ];

                if(!this.dPriPersonaMetaValue.id)
                    this.fuPriPersonaMetaValueCreate(vValue);
                else
                this.fuPriPersonaMetaValueUpdate(vValue);
            }
        },
        fuPerfilSave(){
            if(this.$refs.refPerfilModal.validate()){
                let vValue = [
                    {type: 'text', name: 'perfil', label: 'Perfil', value: this.dPerfil},
                ];

                if(!this.dPriPersonaMetaValue.id)
                    this.fuPriPersonaMetaValueCreate(vValue);
                else
                this.fuPriPersonaMetaValueUpdate(vValue);
            }
        },
        async fuPriPersonaMetaValueCreate (vValue) {
            try {
                this.dPerfilModal.IsUpdating = true;
                this.dPriPersonaMetaValueModal.IsUpdating = true;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation pripersonametavalueCreate($nombre: String, $value: [IsObject], $documento_identidad: String!){
                        pripersonametavalueCreate(nombre:$nombre, value: $value, documento_identidad: $documento_identidad){
                            success
                        }
                    }`,
                    variables: {
                        nombre: this.dPriPersonaMetaValueModal.title,
                        value: vValue,
                        documento_identidad: this.dPriAlumno.DNI,
                    }
                });
                this.fuPrialumnoPriPersonaMetaValue(this.dPriAlumno.IdAlumno);
                Swal.fire('Correcto', 'Se guardó correctamente', 'success');
                this.dPerfilModal.dialog = false;
                this.dPriPersonaMetaValueModal.dialog = false;
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se guardó.', 'error')
            } finally {
                this.dPerfilModal.IsUpdating = false;
                this.dPriPersonaMetaValueModal.IsUpdating = false;
            }
        },
        async fuPriPersonaMetaValueUpdate (vValue) {
            try {
                this.dPerfilModal.IsUpdating = true;
                this.dPriPersonaMetaValueModal.IsUpdating = true;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation pripersonametavalueUpdate($id: ID!, $value: [IsObject]){
                        pripersonametavalueUpdate(id:$id, value: $value){
                            success
                        }
                    }`,
                    variables: {
                        id: this.dPriPersonaMetaValue.id,
                        value: vValue,
                    }
                });
                this.fuPrialumnoPriPersonaMetaValue(this.dPriAlumno.IdAlumno);
                Swal.fire('Correcto', 'Se guardó correctamente', 'success');
                this.dPerfilModal.dialog = false;
                this.dPriPersonaMetaValueModal.dialog = false;
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se guardó.', 'error')
            } finally {
                this.dPerfilModal.IsUpdating = false;
                this.dPriPersonaMetaValueModal.IsUpdating = false;
            }
        },
        fuPriPersonaMetaValueEliminar(item){
            Swal.fire({
                icon: 'question',
                title: 'Confirmación',
                html: '¿Esta seguro de Eliminar?',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si',
                cancelButtonText: 'No',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return this.$apollo.mutate({
                        mutation: gql`mutation pripersonametavalueDelete($id: ID!){
                            pripersonametavalueDelete(id: $id){
                                id
                            }
                        }`,
                        variables: {
                            id: item.id
                        }
                    });
                },
            }).then((result) => {
                // if (result.value){
                //     this.dPriPersonaMetaValue.splice(index, 1)
                // }
                this.fuPrialumnoPriPersonaMetaValue(this.dPriAlumno.IdAlumno);
            })
        },
        async fuPriPersonaMetaValueEdit(item){
            this.dPriPersonaMetaValue = Object.assign({}, this.dPriPersonaMetaValueDefault);
            this.dPriPersonaMetaValueModal.title=item.nombre;
            this.dPriPersonaMetaValue.id = item.id;
            this.dPriPersonaMetaValue.inicio_at = JSON.parse(item.value)[0].value;
            this.dPriPersonaMetaValue.end_at = JSON.parse(item.value)[1].value;
            this.dPriPersonaMetaValue.instituto = JSON.parse(item.value)[2].value;
            this.dPriPersonaMetaValue.carrera = JSON.parse(item.value)[3].value;
            if (JSON.parse(item.value).length>=5)
                this.dPriPersonaMetaValue.detalle = JSON.parse(item.value)[4].value;
            else
                this.dPriPersonaMetaValue.detalle = '';
            
            // JSON.parse(item.value)[4].value ? this.dPriPersonaMetaValue.detalle = JSON.parse(item.value)[4].value ? this.dPriPersonaMetaValue.detalle='';

            this.dPriPersonaMetaValueModal.dialog = true;
        },
        async fuModalDocsSave(){
            if(this.$refs.refModalDocs.validate()){
                this.dModalDocs.IsUpdating = true;
                try {
                    const data= {
                        type: 'FOTO',
                        file: this.dSelectedFile
                    };
                    const response = await this.$apollo.mutate({
                        mutation: gql`mutation prialumnoUploadDocs($IdAlumno: ID!, $file: uploadDocAlumno!){
                            prialumnoUploadDocs(IdAlumno: $IdAlumno, file: $file) {
                                data
                                message
                                success
                            },
                        }`,
                        variables: {
                            IdAlumno: this.$route.params.pIdAlumno,
                            file: data,
                        }
                    });
                    this.dPriAlumno.docs = '';
                } catch (error) {
                    console.log(error);
                    Swal.fire('¡ ERROR !', 'No se guardó.', 'error')
                } finally {
                    this.dModalDocs.IsUpdating = false;
                    this.dModalDocs.dialog = false;
                    this.dSelectedFile = null;
                    this.fuLoad(parseInt(this.$route.params.pIdAlumno));
                }
            }
        },
        fuPdf(){
            var element = document.getElementById('element-to-pdf');
            var opt = {
                margin: 0,
                filename: this.dPriAlumno.DNI+'.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 3 },
                jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
                useCORS: true
            };
            html2pdf().from(element).set(opt).save();
        },
        fImage(url) {
            const endPoint = 'https://apigraphql.khipu.edu.pe/graphql/'
            const query = `
            query {
                downloadImageAsBase64(url: "https://proxy.khipu.edu.pe/${url}")
            }`;

            fetch(endPoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    query: query
                })
            }).then(response => response.json())
            .then(data => {
                this.dFoto = 'data:image/png;base64,' +  data.data.downloadImageAsBase64;
            })
        }
    }
}
</script>
<style scoped>
    .portrait {
        margin: 0 auto;
        max-width: 800px;
        width: 100%;
    }
</style>